import { createFileRoute } from "@tanstack/react-router";

import AddTiebreakWinPage from "~/pages/gameSession/AddTiebreakWinPage.tsx";

export const Route = createFileRoute("/_auth/game-session/$gameSessionId/tiebreak-win")({
    component: AddTiebreakWinPage,
});
